import { Component, OnInit, Input, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { LocalStorageService } from 'src/app/services/shared/local-storage/local-storage.service';

@Component({
    selector: 'app-confirmation-dialog',
    templateUrl: './confirmation-dialog.component.html',
    styleUrls: ['./confirmation-dialog.component.scss'],
    standalone: false
})
export class ConfirmationDialogComponent implements OnInit {

  @Input() title: string;
  @Input() message: string;
  @Input() subMessage: string = 'Se eliminará toda la información seleccionada en esta fuente.';
  @Input() btnOkText: string;
  @Input() btnCancelText: string;
  @Input() btnThirdText: string; // Tercer botón opcional
  @Input() showComment: boolean = false;
  @Input() commentLabel: string = 'Comentarios';
  @Input() commentRequired: boolean = false;
  @Input() icon: string = '';
  @Input() options: any = null;

  titleModal: boolean = true;
  mostrarPiepagina: boolean = true;
  text: string = '';
  useCustomTemplate: boolean = false;

  showVIPUY: boolean = false;

  constructor(
    private dialogRef: MatDialogRef<ConfirmationDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private localStorageService: LocalStorageService,
  ) {

    if (data) {

      console.log('Datos recibidos en el diálogo:', data);
      this.title = data.title;
      this.message = data.message;
      this.subMessage = data.subMessage || 'Se eliminará toda la información seleccionada en esta fuente.';
      this.btnOkText = data.btnOkText;
      this.btnCancelText = data.btnCancelText;
      this.btnThirdText = data.btnThirdText;
      this.showComment = data.showComment || false;
      this.commentLabel = data.commentLabel || 'Comentarios';
      this.commentRequired = data.commentRequired || false;
      this.icon = data.icon || '';
      this.options = data.options || null;

      if (this.options) {
        this.useCustomTemplate = true;
        this.icon = this.options.icon || this.icon;
        this.btnOkText = this.options.buttonPrimary || this.btnOkText || 'Aceptar';
        this.btnCancelText = this.options.buttonSecondary || this.btnCancelText || 'Cancelar';
      }
    }
  }

  ngOnInit() {
    if (this.useCustomTemplate) {
      this.mostrarPiepagina = false;
      return;
    }

    this.showVIPUY = false;
    if (
      this.title == "Cancelar modificación" ||
      this.title == "¿Descartar cambios?" ||
      this.title == "Agregar Información" ||
      this.title == "Eliminar Información" ||
      this.localStorageService.esInternoRDS ||
      this.localStorageService.getIsExternoRDS
    ) {
      this.mostrarPiepagina = false;
    }

    if (this.localStorageService.getIsVip && this.localStorageService.getCountryString === 'UY') {
      this.showVIPUY = this.localStorageService.keyUpdates.includes('delete_date') ? true : false;
    }

  }

  get customContainerClass(): string {
    return this.options?.positionContainer === 'center' ? 'custom-dialog-center' : '';
  }

  get customIconSize(): string {
    return this.options?.iconSize || '24px';
  }

  get customIconColor(): string {
    const iconColor = this.options?.iconColor;

    if (!iconColor) {
      return '#2e7d32';
    }


    if (iconColor.startsWith('#')) {
      return iconColor;
    }


    const colorMap: { [key: string]: string } = {
      'success': '#2e7d32',
      'error': '#dc3545',
      'warning': '#ff9800',
      'info': '#2196f3',
      'primary': '#1976d2'
    };

    return colorMap[iconColor.toLowerCase()] || iconColor;
  }

  get showPrimaryButton(): boolean {
    return this.options?.buttonActive !== false;
  }

  get showSecondaryButton(): boolean {
    return this.options?.buttonSecondaryActive === true;
  }

  public decline() {

    if (this.btnThirdText) {
      this.dialogRef.close(true);
    } else {

      this.dialogRef.close(false);
    }
  }

  get acceptDisabled(): boolean {
    return this.showComment && this.commentRequired && !this.text?.trim();
  }

  public accept() {
    if (this.acceptDisabled) {
      return;
    }
    // Siempre sincronizar el comentario del textarea con el localStorage,
    // incluso si está vacío, para evitar que quede un valor residual de una operación anterior.
    if (this.showComment) {
      this.localStorageService.comment = this.text;
    }

    if (this.btnThirdText) {
      this.dialogRef.close(false);
    } else {

      this.dialogRef.close(true);
    }
  }

  public third() {
    this.dialogRef.close('third');
  }

  public dismiss() {
    this.dialogRef.close(false);
  }

}
